import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      type: 'video',
      src: 'https://customer-assets.emergentagent.com/job_9488e97a-b5e4-42e0-a94e-fc381306b65d/artifacts/c2c0zz23_0%20Pizza%20Ingredients%201280X720%20small.mp4',
    },
    {
      type: 'image',
      src: 'https://images.unsplash.com/photo-1513104890138-7c749659a591?w=1920&q=80',
    },
    {
      type: 'image',
      src: 'https://images.unsplash.com/photo-1571997478779-2adcbbe9ab2f?w=1920&q=80',
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section id="hero" className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            {slide.type === 'video' ? (
              <video
                key={slide.src}
                src={slide.src}
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                className="w-full h-full object-cover"
                onLoadedData={(e) => e.target.play()}
              />
            ) : (
              <img
                src={slide.src}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover"
              />
            )}
          </div>
        ))}
      </div>

      <div className="absolute inset-0 bg-black/50" />

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4">
        <div className="mb-4 text-red-500 text-sm font-semibold tracking-widest uppercase">
          Est. 2024
        </div>
        <h1 className="text-white mb-6">
          <div className="text-6xl md:text-8xl font-bold mb-2 tracking-wider">
            RAVINTOLA
          </div>
          <div className="text-6xl md:text-8xl font-bold tracking-wider">
            VILPPULA
          </div>
        </h1>
        <p className="text-white/90 text-lg md:text-xl mb-8 max-w-2xl">
          Aitoja makuja, pizzaherkkuja ja viihtyisä tunnelma Vilppulassa.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="https://www.restaurantlogin.com/api/fb/_rk_r6d"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              size="lg"
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-6 text-lg font-semibold transition-all duration-300 hover:scale-105"
            >
              Tilaa verkosta
            </Button>
          </a>
          <a
            href="https://www.restaurantlogin.com/api/res/_rk_r6d"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-black px-8 py-6 text-lg font-semibold transition-all duration-300 hover:scale-105"
            >
              Varaa pöytä
            </Button>
          </a>
        </div>
      </div>

      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white p-3 rounded-full transition-all duration-300 hover:scale-110"
      >
        <ChevronLeft size={24} />
      </button>
      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white p-3 rounded-full transition-all duration-300 hover:scale-110"
      >
        <ChevronRight size={24} />
      </button>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === currentSlide
                ? 'bg-red-600 w-8'
                : 'bg-white/50 hover:bg-white/70'
            }`}
          />
        ))}
      </div>
    </section>
  );
};

export default HeroSection;
